import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import StripeForm from './forms/stripe-form'
import BraintreeForm from './forms/braintree-form'
import PaymentSummary from './payment-summary'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

function PaymentSection({league, token, type, paymentParams, cards, defaultCard, formData, onBack, onComplete}) {
  const isStripe = paymentParams.processor == 'stripe'
  const [stripePromise, setStripePromise] = useState(null)

  useEffect(() => {
    if (isStripe) createStripePromise()
  }, [])

  const createStripePromise = () => {
    const accountOptions = paymentParams.account ? {stripeAccount: paymentParams.account} : {}
    setStripePromise(() => loadStripe(paymentParams.publishable_key, accountOptions))
  }

  return <div className='payment-section'>
    <div className='payment-section-content'>
      { isStripe && 
        <Elements stripe={stripePromise}>
          <StripeForm
            league={league}
            type={type}
            token={token}
            cards={cards}
            defaultCard={defaultCard}
            formData={formData}
            onBack={onBack}
            onComplete={onComplete}
          />
        </Elements>
      }
      { !isStripe && 
        <BraintreeForm
          league={league}
          type={type}
          cards={cards}
          formData={formData}
          paymentParams={paymentParams}
          onBack={onBack}
          onComplete={onComplete}
        />
      }
      <PaymentSummary league={league} type={type} />
    </div>
  </div>
}

PaymentSection.propTypes = {
  league: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  paymentParams: PropTypes.object.isRequired,
  cards: PropTypes.array.isRequired,
  formData: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
}

export default PaymentSection
